/**
 * Infinite logo carousel for .bts-companies-logs
 */
const PIXELS_PER_SECOND = 50;

function wrapListAsTrack( list ) {
	const carousel = document.createElement( 'div' );
	carousel.className = 'bts-companies-logs__carousel';

	const viewport = document.createElement( 'div' );
	viewport.className = 'bts-companies-logs__viewport';

	list.classList.remove( 'bts-companies-logs__list' );
	list.classList.add( 'bts-companies-logs__track' );

	viewport.appendChild( list );
	carousel.appendChild( viewport );

	list.parentNode.insertBefore( carousel, list );
}

function setCarouselDuration( track ) {
	const halfWidth = track.scrollWidth / 2;
	const duration = Math.max( halfWidth / PIXELS_PER_SECOND, 10 );
	track.style.setProperty( '--carousel-duration', `${ duration }s` );
}

function initTrack( track ) {
	if ( track.dataset.carouselReady === 'true' ) {
		return;
	}

	const items = track.querySelectorAll( '.bts-companies-logs__item' );
	if ( items.length < 2 ) {
		track.dataset.carouselReady = 'true';
		return;
	}

	items.forEach( ( item ) => {
		track.appendChild( item.cloneNode( true ) );
	} );

	const prefersReducedMotion = window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;

	if ( ! prefersReducedMotion ) {
		const updateDuration = () => setCarouselDuration( track );

		if ( document.fonts && document.fonts.ready ) {
			document.fonts.ready.then( updateDuration );
		}

		const images = track.querySelectorAll( 'img' );
		let pending = images.length;

		if ( pending === 0 ) {
			updateDuration();
		} else {
			images.forEach( ( img ) => {
				if ( img.complete ) {
					pending -= 1;
					if ( pending === 0 ) {
						updateDuration();
					}
				} else {
					img.addEventListener( 'load', () => {
						pending -= 1;
						if ( pending === 0 ) {
							updateDuration();
						}
					} );
					img.addEventListener( 'error', () => {
						pending -= 1;
						if ( pending === 0 ) {
							updateDuration();
						}
					} );
				}
			} );
		}

		window.addEventListener( 'resize', updateDuration );
		track.classList.add( 'is-animated' );
	}

	track.dataset.carouselReady = 'true';
}

export default function initCarousel() {
	document.querySelectorAll( '.bts-companies-logs' ).forEach( ( section ) => {
		let track = section.querySelector( '.bts-companies-logs__track' );
		const list = section.querySelector( '.bts-companies-logs__list' );

		if ( ! track && list ) {
			wrapListAsTrack( list );
			track = section.querySelector( '.bts-companies-logs__track' );
		}

		if ( track ) {
			initTrack( track );
		}
	} );
}
